import { TabsComponent } from "@theme/tabs";
import { isDesktopBreakpoint } from "@theme/utilities";

export class CollectionsWithBackground extends TabsComponent {
  handleDesignMode() {
    this.addEventListener('shopify:block:select', (e) => {
      if (!this.contains(e.target)) return;
      const panel = e.target.closest('.tabs-content__item');
      const index = this.panels.indexOf(panel);
      if (index < 0) return;

      if (isDesktopBreakpoint()) {
        this.setSelectedIndex(index);
        return;
      }

      if (this.classList.contains('mobile-layout-horizontal')) {
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    });
  }
}

if (!customElements.get('collections-with-background')) {
  customElements.define('collections-with-background', CollectionsWithBackground);
}
